var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_12667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4165 2.33301V5.83301H9.9165",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.583496 11.667V8.16699H4.0835",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04766 5.2496C2.34351 4.41355 2.84632 3.66608 3.50918 3.07692C4.17205 2.48777 4.97335 2.07613 5.83833 1.88041C6.70331 1.6847 7.60377 1.7113 8.45569 1.95771C9.30761 2.20413 10.0832 2.66235 10.7102 3.2896L13.4168 5.83293M0.583496 8.16626L3.29016 10.7096C3.9171 11.3368 4.69271 11.7951 5.54463 12.0415C6.39656 12.2879 7.29702 12.3145 8.162 12.1188C9.02697 11.9231 9.82828 11.5114 10.4911 10.9223C11.154 10.3331 11.6568 9.58564 11.9527 8.7496",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_12667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1dc5bd2953e89d5cdc0bd9da399e6f8d.svg";
export { ForwardRef as ReactComponent };